// ─── Il mio account ──────────────────────────────────────────────────────────
//
// ⭐⭐ NASCE DALLA BARRA A SINISTRA CHE SI SVUOTA — 17/09/2026, richiesta sua.
//
// 🗣️ *«vorrei che si levasse la mail più la scritta owner, magari questa roba
// può andare giù in fondo nella sezione la mia password, che potrebbe diventare
// il mio account, che lì un po' gestisci tutto l'account»*
//
// ⚖️ Email e ruolo non sono stati CANCELLATI, sono stati SPOSTATI: sono due
// cose che si guardano quando ci si chiede *«con quale accesso sono dentro?»* —
// cioè una volta ogni tanto — e stavano sotto gli occhi tutto il giorno, in una
// barra dove serve invece il numero di versione.
// 📌 *Un dato che si consulta di rado non si toglie: si mette dove lo si va a
//    cercare.*
//
// 🚨 E QUI SI DICE ANCHE CIÒ CHE **NON** SI PUÒ FARE DA QUI. Nome ed email non
// li cambia il proprio accesso, li cambia un proprietario da Impostazioni →
// Utenti staff: scriverlo costa una riga, e scoprirlo cercando un bottone che
// non c'è costa molto di più.

import { CAPITOLI, ETICHETTE, ETICHETTE_RUOLO } from '@pmo/shared';
import { useSessione } from '../../features/auth/sessione.js';
import { usaVersione } from '../../features/versione.js';
import { CambioPassword } from '../accesso/CambioPassword.js';

export function MioAccount(): React.JSX.Element | null {
  const { profilo } = useSessione();
  const versione = usaVersione();

  // Non capita: a questa schermata ci si arriva solo da dentro. Ma il tipo dice
  // che può mancare, e inventarsi un profilo vuoto mostrerebbe trattini al
  // posto dei dati invece di non mostrare niente.
  if (!profilo) return null;

  return (
    <section className="mio-account">
      <header className="testata">
        <h2>Il mio account</h2>
        <p className="tenue">Con quale accesso sei dentro, cosa puoi aprire, e la password.</p>
      </header>

      <div className="riquadro">
        <h2>Chi sei</h2>
        <dl>
          <dt>Nome</dt>
          <dd>{profilo.fullName ?? '—'}</dd>
          <dt>Email</dt>
          <dd>{profilo.email}</dd>
          <dt>Ruolo</dt>
          <dd>{ETICHETTE_RUOLO[profilo.role]}</dd>
        </dl>
        {/* 🚨 Un `readonly` deve saperlo PRIMA di premere «Salva»: il server
            rifiuta ogni scrittura da questo accesso, e un rifiuto scoperto
            premendo sembra un guasto del gestionale. */}
        {profilo.role === 'readonly' && (
          <p className="tenue piccolo">
            Questo accesso può guardare tutto quello che trova qui sotto, e non può cambiare niente: il server
            rifiuta ogni scrittura.
          </p>
        )}
        <p className="tenue piccolo">
          Nome ed email li cambia un proprietario da Impostazioni → Utenti staff: da qui si cambia solo la
          password.
        </p>
      </div>

      <div className="riquadro">
        <h2>Cosa puoi aprire</h2>
        <PermessiMiei permessi={profilo.permissions} />
      </div>

      <CambioPassword obbligato={false} />

      <p className="tenue piccolo">
        Gestionale Padel Village{versione === null ? '' : ` · versione ${versione}`}
      </p>
    </section>
  );
}

/**
 * I permessi raggruppati per capitolo, come nella schermata degli utenti staff.
 *
 * ⚖️ Un elenco piatto di quattordici spunte non si legge: «Anagrafica» da sola
 * non dice di cosa, e messa sotto «Soci» sì. La struttura è la stessa di
 * `CAPITOLI`, e sta in un posto solo apposta — se un domani nasce un capitolo
 * nuovo, questa schermata lo mostra senza che nessuno la tocchi.
 */
function PermessiMiei({ permessi }: { permessi: readonly string[] }): React.JSX.Element {
  const gruppi = CAPITOLI.map((c) => ({
    titolo: c.titolo,
    ha: permessi.includes(c.capitolo),
    dentro: c.sottosezioni.filter((s) => permessi.includes(s)),
  })).filter((g) => g.ha);

  if (gruppi.length === 0) {
    return (
      <p className="tenue">
        Nessuna sezione è aperta per questo accesso. Le spunte le mette un proprietario da Impostazioni →
        Utenti staff.
      </p>
    );
  }

  return (
    <ul className="elenco-permessi">
      {gruppi.map((g) => (
        <li key={g.titolo}>
          <strong>{g.titolo}</strong>
          {g.dentro.length > 0 && (
            <span className="tenue piccolo">
              {' '}
              — {g.dentro.map((s) => ETICHETTE[s as keyof typeof ETICHETTE]).join(' · ')}
            </span>
          )}
        </li>
      ))}
    </ul>
  );
}
